angular.module('qkr').factory('verificationService', ($http, appConfig) => ({

		completeRegistration(form) {
	             return $http.post(appConfig.apiUrl + 'registration/completeRegistration', angular.copy(form))
	             	.then((response) => response.data);
	        },


    getConsentLanguage(termCondition) {
        const path = appConfig.pathPrefix + '/masterCardAdmin/termsConditions?type='+
            termCondition.type +'&locale='+termCondition.locale

        return $http.post(path);
    }
    }));




// WEBPACK FOOTER //
// ./src/services/verification.service.js